import { Wifi, WifiOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface LiveIndicatorProps {
  isConnected: boolean;
  lastUpdate?: Date;
}

const LiveIndicator = ({ isConnected, lastUpdate }: LiveIndicatorProps) => {
  const { t } = useTranslation();

  return (
    <div className={`flex items-center gap-2 sm:gap-3 px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg sm:rounded-xl text-xs sm:text-sm transition-all duration-300 ${
      isConnected ? 'bg-success/10' : 'bg-destructive/10'
    }`}>
      {isConnected ? (
        <>
          <div className="flex items-center gap-1.5 sm:gap-2">
            <span className="relative flex h-2 sm:h-2.5 w-2 sm:w-2.5">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-success opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 sm:h-2.5 w-2 sm:w-2.5 bg-success"></span>
            </span>
            <Wifi className="w-3.5 sm:w-4 h-3.5 sm:h-4 text-success" />
            <span className="text-success font-semibold">{t('live.connected')}</span>
          </div>
          {lastUpdate && (
            <span className="text-muted-foreground text-[10px] sm:text-xs hidden sm:inline">
              {lastUpdate.toLocaleTimeString()}
            </span>
          )}
        </>
      ) : (
        <div className="flex items-center gap-1.5 sm:gap-2">
          <WifiOff className="w-3.5 sm:w-4 h-3.5 sm:h-4 text-destructive" />
          <span className="text-destructive font-semibold">{t('live.disconnected')}</span>
        </div>
      )}
    </div>
  );
};

export default LiveIndicator;
